import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=6b0900d6&scoped=true"
import script from "./Novidades.vue?vue&type=script&lang=js"
export * from "./Novidades.vue?vue&type=script&lang=js"
import style0 from "./Novidades.vue?vue&type=style&index=0&id=6b0900d6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0900d6",
  null
  
)

export default component.exports